<template>
  <section class="bootcamp-intro">
    <h3 class="section-subtitle">{{ intros.subtitle }}</h3>
    <h2 class="section-title">{{ intros.title }}</h2>
    <p class="section-description">
      {{ intros.description }}
    </p>
    <div class="intro-cards">
      <IntroCard v-for="card in introCards" :key="card.title" :card="card" />
    </div>
  </section>
</template>

<script>
import IntroCard from "@/components/bootcamp/enroll/intro/IntroCard.vue"
import { mapGetters } from "vuex"
export default {
  components: {
    IntroCard,
  },
  computed: {
    ...mapGetters("BootcampEnroll", ["bootcampIntrosByKey"]),
    key () {
      return this.$route.params.key || this.$route.path.replace("/", "")
    },
    intros () {
      return this.bootcampIntrosByKey(this.key)
    },
    introCards () {
      const intros = this.intros.cards
      if (["sm", "xs"].includes(this.$mq)) {
        return intros.slice(0, 3)
      }
      return intros
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.bootcamp-intro {
  padding-top: 7rem;
  padding-bottom: 6.5rem;
  width: 95%;
  margin: 0 auto;
  @include tablet-down {
    padding-top: 4.1rem;
    padding-bottom: 5.1rem;
  }
  .intro-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 3rem;
    max-width: 111.9rem;
    margin: 3rem auto 0;
    @include tablet-down {
      margin-top: 2rem;
      gap: 2rem;
    }
    @include phone-down {
      grid-template-columns: 1fr;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/intro/TheBootcampIntro.vue